import type { ProductResponse } from '~/types/on24-klient'
import { useQuery } from '@tanstack/vue-query'
import { usePageQuery } from './shared'

const query = (productId: string, hallId: Ref<string | undefined>) => {
  const app = useNuxtApp()

  return useQuery({
    queryKey: ['product', productId, hallId],
    queryFn: async () => {
      return await app.$api<ProductResponse>(`/p/${productId}`, {
        query: {
          hall: hallId.value,
        },
      })
    },
  })
}

export const useProductQuery = usePageQuery(query)
